enum ErrorActionsEnum {
    ErrorSet = 'ERROR/SET',
}

export default ErrorActionsEnum;
